const options = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function CelebrationProcessingTimeSection() {
  return (
    <section id="processing-options" className="bg-white pt-8 pb-20 md:pt-10 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Processing Times</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Processing Options in Celebration
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Celebration travelers have several options. Here's how they compare — and why most choose a U.S. Department of State registered passport courier agency to handle their passport.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {options.map((opt, i) => (
            <div
              key={i}
              className={`relative rounded-lg p-6 flex flex-col ${
                opt.highlight
                  ? "bg-[#1A365D] text-white border-2 border-[#F6C344]"
                  : opt.emergency
                  ? "bg-[#F7F8FA] border border-gray-200"
                  : opt.smartSaver
                  ? "bg-[#F7F8FA] border-2 border-green-400"
                  : "bg-[#F7F8FA] border border-gray-200"
              }`}
            >
              {opt.highlight && (
                <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#F6C344] text-[#1A365D] text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap">
                  Recommended
                </div>
              )}
              <span className={`self-start text-xs font-semibold px-2.5 py-1 rounded-full mb-4 whitespace-nowrap ${opt.tagColor}`}>
                {opt.tag}
              </span>
              <div className="mb-1">
                <span className={`font-serif text-4xl font-bold ${opt.highlight ? "text-[#F6C344]" : "text-[#1A365D]"}`}>
                  {opt.speed}
                </span>
              </div>
              <p className={`text-sm font-semibold mb-1 ${opt.highlight ? "text-white/70" : "text-gray-400"}`}>
                {opt.unit}
              </p>
              <h3 className={`font-bold text-base mb-4 ${opt.highlight ? "text-white" : "text-[#1A365D]"}`}>
                {opt.label}
              </h3>
              {opt.emergency && (
                <p className="text-xs text-gray-400 italic mb-3 leading-relaxed">
                  Strictly for documented life-or-death emergencies. You must obtain an appointment in advance — no walk-ins permitted.
                </p>
              )}
              <ul className="space-y-2 flex-1">
                {opt.features.map((f, j) => {
                  const isShutdown = f === "Not affected by government shutdowns";
                  const isAgent = f === "Dedicated agent assigned to your case";
                  const isUpdates = f === "Daily status updates — never left guessing";
                  const isNoAgent = f === "No dedicated agent — you are on your own";
                  const isMailUpdates = f === "Updates only by physical mail letter";
                  const isNoContact = f === "No phone or email contact for your case";
                  const isAgentBlock = isAgent || isUpdates;
                  const isNoAgentBlock = isNoAgent || isMailUpdates || isNoContact;
                  const showTopDivider = isShutdown || isAgent || isNoAgent;

                  return (
                    <li
                      key={j}
                      className={`flex items-start gap-2 text-sm ${
                        showTopDivider
                          ? `mt-3 pt-3 border-t ${opt.highlight ? "border-white/20" : "border-gray-200"}`
                          : ""
                      }`}
                    >
                      <i
                        className={`flex-shrink-0 mt-0.5 ${
                          isShutdown
                            ? "ri-shield-check-line text-green-400"
                            : isAgentBlock
                            ? opt.highlight
                              ? "ri-user-line text-[#F6C344]"
                              : "ri-user-line text-[#1A365D]"
                            : isNoAgentBlock
                            ? "ri-close-line text-red-400"
                            : opt.muted
                            ? "ri-close-line text-red-400"
                            : opt.highlight
                            ? "ri-check-line text-[#F6C344]"
                            : "ri-check-line text-[#F6C344]"
                        }`}
                      ></i>
                      <span
                        className={`${
                          isShutdown
                            ? opt.highlight
                              ? "text-green-300 font-semibold"
                              : "text-green-700 font-semibold"
                            : isAgentBlock
                            ? opt.highlight
                              ? "text-white font-semibold"
                              : "text-[#1A365D] font-semibold"
                            : isNoAgentBlock
                            ? "text-gray-700 font-semibold"
                            : opt.highlight
                            ? "text-white/80"
                            : opt.muted
                            ? "text-gray-600"
                            : "text-gray-600"
                        }`}
                      >
                        {f}
                      </span>
                    </li>
                  );
                })}
              </ul>
              {opt.emergency && (
                <div className="mt-6">
                  <a
                    href="#comparison"
                    className="inline-flex items-center justify-center gap-2 border border-gray-300 hover:border-[#1A365D] text-gray-500 hover:text-[#1A365D] font-semibold text-sm px-4 py-2.5 rounded-md transition-all whitespace-nowrap w-full"
                  >
                    More Info <i className="ri-information-line"></i>
                  </a>
                </div>
              )}
              {opt.highlight && (
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="mt-6 inline-flex items-center justify-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-4 py-3 rounded-md transition-all whitespace-nowrap"
                >
                  Start Now <i className="ri-arrow-right-line"></i>
                </a>
              )}
              {opt.smartSaver && (
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="mt-6 inline-flex items-center justify-center gap-2 border border-[#1A365D]/20 hover:border-[#1A365D] text-[#1A365D] font-bold text-sm px-4 py-3 rounded-md transition-all whitespace-nowrap"
                >
                  Start Now <i className="ri-arrow-right-line"></i>
                </a>
              )}
              {opt.muted && (
                <a
                  href="#acceptance-facilities"
                  className="mt-6 inline-flex items-center justify-center gap-2 border border-gray-300 hover:border-gray-400 text-gray-400 hover:text-gray-600 font-semibold text-sm px-4 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  More Info <i className="ri-information-line"></i>
                </a>
              )}
            </div>
          ))}
        </div>
        <p className="text-center text-gray-400 text-xs mt-6">
          *Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing.
        </p>
      </div>
    </section>
  );
}